<template>
  <div>
    <div class="d-flex align-center mt-2">
      <v-sheet color="grey-8" height="60" rounded width="100%" class="d-flex align-center px-2">
        <div class="d-flex" style="width: 400px; max-width: 70%;">
          <v-text-field
            v-model="search"
            v-on:keyup.enter="searchBlacklist()"
            single-line
            hide-details
            outlined
            dense
            clearable
            :placeholder="'輸入姓名/手機/民國生日(例801231)'"
          />
        </div>
        <v-btn icon color="primary" class="ml-2" @click="searchBlacklist()">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-spacer/>
        <div class="ml-auto" style="width: 320px;">
          <v-text-field v-model="phone" placeholder="輸入手機號碼" outlined hide-details dense clearable/>
        </div>
        <v-btn class="ml-2" color="primary" @click="addBlacklist()">新增黑名單</v-btn>
      </v-sheet>
    </div>

    <v-data-table
      :headers="headers"
      :items="blacklists"
      :options.sync="options"
      :footer-props="{ itemsPerPageOptions: [100] }"
      :loading="loading"
      fixed-header
      height="calc(100vh - 380px)"
      item-key="_uid"
    >
      <template v-slot:item.action="{ item }">
        <v-btn icon color="primary" @click="deleteBlacklist(item.id)">
          <v-icon dark>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.sex="{ item }">
        <span v-show="item.sex == 0">女</span>
        <span v-show="item.sex == 1">男</span>
        <span v-show="item.sex == 9">未知</span>
      </template>
      <template v-if="isClinicType" v-slot:item.blacklist_note="{ item }">
        <div class="d-flex align-center justify-center">
          <span class="text-truncate" style="max-width: 200px;" :title="item.blacklist_note">{{ item.blacklist_note }}</span>
          <v-btn icon x-small class="ml-1" @click="openNoteDialog(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="noteDialog" max-width="500">
      <v-card>
        <v-card-title>黑名單院內備註</v-card-title>
        <v-card-text>
          <v-textarea
            v-if="noteDialog"
            ref="noteRef"
            :value="editingNote"
            outlined
            placeholder="請輸入備註內容"
            rows="4"
            no-resize
            clearable
            hide-details
            counter="500"
            maxlength="500"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            :loading="noteSaving"
            @click="saveNote"
          >確定修改</v-btn>
          <v-btn dark color="grey-4" @click="noteDialog = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { addBlacklistAPI, deleteBlacklistAPI, getBlacklistsAPI, updateBlacklistNoteAPI } from '../../api';

export default {
  name: "Blacklist",

  components: {},

  data() {
    return {
      loading: false,
      search: null,
      phone: '',
      blacklists: [],
      options: {},
      totalBlacklist: 0,
      noteDialog: false,
      noteSaving: false,
      editingNote: '',
      editingItem: null,
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
    ]),
    isClinicType() {
      return this.axiosParamData.type === '1'
    },
    headers() {
      const cols = [
        { text: '姓名', align: 'center', value: 'patient_name', sortable: false, width: 120 },
        { text: '手機', align: 'center', value: 'value', sortable: false, width: 120 },
        { text: '性別', align: 'center', value: 'sex', sortable: false, width: 120 },
        { text: '生日', align: 'center', value: 'birthday', sortable: false, width: 80 },
      ]
      if (this.isClinicType) {
        cols.push({ text: '院內備註', align: 'center', value: 'blacklist_note', sortable: false, width: 200 })
      }
      cols.push({ text: '功能', align: 'center', value: 'action', sortable: false, width: 80 })
      return cols
    },
  },

  watch: {
    search () {
      if (this.search === '' || this.search === null) {
        this.getBlacklists()
      }
    }
  },

  methods: {
    openNoteDialog(item) {
      this.editingItem = item
      this.editingNote = item.blacklist_note || ''
      this.noteDialog = true
    },
    saveNote() {
      const value = this.$refs.noteRef.internalValue || ''
      this.noteSaving = true
      const data = {
        clinic_code: this.axiosParamData.clinic_code,
        patient_code: this.editingItem.patient_code,
        blacklist_note: value,
      }
      updateBlacklistNoteAPI(data).then(() => {
        this.editingItem.blacklist_note = value
        this.noteDialog = false
      }).catch(e => {
        const messages = e.response?.data?.messages || ''
        if (messages !== '') {
          this.$notify.error(messages)
        } else {
          this.$notify.error(this.$t('GENERAL.oops'))
        }
      }).finally(() => {
        this.noteSaving = false
      })
    },
    addBlacklist () {
      if (this.phone === '') {
        this.$notify.warning('請輸入手機號碼')
        return false;
      }
      const vm = this;
      this.loading = true
      const data = {
        ...this.axiosParamData,
        phone: this.phone
      };
      addBlacklistAPI(data).then(res => {
        vm.getBlacklists();
      }).catch(e => {
        const messages = e.response.data.messages || '';

        if (messages !== '') {
          this.$notify.error(messages)
        } else {
          this.$notify.error(this.$t('GENERAL.oops'))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    async deleteBlacklist (id) {
      if (!await this.$notify.confirm('確定刪除？')) return
      const vm = this;
      this.loading = true
      const params = {
        ...this.axiosParamData,
        id: id
      };
      deleteBlacklistAPI(params).then(res => {
        vm.getBlacklists();
      }).catch(e => {
        this.$notify.error(this.$t('GENERAL.oops'))
        console.error(e)
      }).finally(() => {

      })
    },
    searchBlacklist() {
      this.getBlacklists();
    },
    getBlacklists() {
      this.loading = true
      const params = {
        ...this.axiosParamData,
        search: this.search || null
      }
      getBlacklistsAPI(params).then(res => {
        this.totalBlacklist = parseInt(res.data.total)
        this.blacklists = res.data.data.map((item, index) => ({
          ...item,
          _uid: `${item.id}_${item.patient_code || index}`,
        }))
      }).catch(e => {
        this.$notify.error(this.$t('GENERAL.oops'))
        console.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
  },

  mounted() {
    this.getBlacklists()
  }
}
</script>

<style scoped></style>
